import { useSelector } from 'store';
import { useMemo } from 'react';
import { DateTime } from 'luxon';
import RFPResponseStatus from 'types/RFPResponseStatus';

const useInfoData = () => {
  const loading = useSelector((state) => state.rfpReviewerList.loading);
  const projects = useSelector((state) => state.rfpReviewerList.data);

  return useMemo(() => {
    let nextCloseDate: DateTime = DateTime.invalid('Just invalid!');
    let projectCounts: Record<RFPResponseStatus | 'all', number> = {
      [RFPResponseStatus.OPEN]: 0,
      [RFPResponseStatus.IN_REVIEW]: 0,
      [RFPResponseStatus.FINAL]: 0,
      all: projects.length,
    };

    const now = DateTime.now();

    projects.forEach((project) => {
      // Collect latest date
      const closeDate = DateTime.fromISO(project.traro_rfp.response_close_date);

      if (now <= closeDate && (!nextCloseDate.isValid || nextCloseDate > closeDate)) {
        nextCloseDate = closeDate;
      }

      projectCounts[project.rfp_response_status] += 1;
    });

    return {
      loading,
      nextCloseDate,
      projectCounts,
    } as const;
  }, [projects, loading]);
};

export default useInfoData;
